export const locales = ['us', 'ca', 'au', 'jp', 'uk', 'eu', 'de', 'fr', 'es', 'it', 'za', 'kr', 'br', 'mx', 'ph', 'nl'];
export const newHeaderLocales = ['us', 'ca', 'de', 'fr', 'za', 'eu', 'uk', 'it', 'es', 'au', 'kr', 'jp', 'cn', 'sa', 'br', 'mx', 'ph', 'nl'];
